import type { ReactNode } from 'react'
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
  CardContent,
} from '@/components/ui/card'
import { useSession } from '@/features/auth/session'

// TODO: reemplazar los "--" por metricas reales cuando la API de admin
// exponga conteos agregados (noticias publicadas, usuarios activos).
export function DashboardHome(): ReactNode {
  const { user } = useSession()
  const firstName = user?.nombre.trim() || 'admin'

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">
          Hola, {firstName}
        </h1>
        <p className="text-sm text-muted-foreground">
          Este es el panel de administración de la Escuela de Sommeliers.
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
        <MetricCard title="Noticias publicadas" />
        <MetricCard title="Usuarios activos" />
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Próximos pasos</CardTitle>
          <CardDescription>
            Aún estamos armando el panel. En los próximos releases vas a poder
            gestionar noticias y ver el listado de usuarios.
          </CardDescription>
        </CardHeader>
      </Card>
    </div>
  )
}

function MetricCard({ title }: { title: string }): ReactNode {
  return (
    <Card>
      <CardHeader>
        <CardDescription>{title}</CardDescription>
        <CardTitle className="text-3xl">—</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-xs text-muted-foreground">
          Dato pendiente en la API.
        </p>
      </CardContent>
    </Card>
  )
}
